require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/old_vendors/moment/pt.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/old_vendors/moment/pt.legacy.js
// module id = 591
// module chunks = 31